export const SmartSendSubType = 'Sold';
